module.exports = __webpack_public_path__ + "img/my-comissions.b9552e9b.svg";